module.exports = __webpack_public_path__ + "img/vector3.d39ce53c.png";